export default __webpack_public_path__ + "static/media/05.17636b11.jpg";